/* ============================================
   RIPVault — Theme JavaScript
   ============================================ */

(function () {
  'use strict';

  // ---- Header: scroll effect ----
  const header = document.getElementById('rv-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 20) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  // ---- Mobile nav toggle ----
  const hamburger = document.getElementById('rv-hamburger');
  const mobileNav = document.getElementById('rv-mobile-nav');
  const overlay   = document.getElementById('rv-overlay');
  const navClose  = document.getElementById('rv-nav-close');

  function openNav() {
    if (!mobileNav || !overlay) return;
    mobileNav.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
  }

  function closeNav() {
    if (!mobileNav || !overlay) return;
    mobileNav.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
  }

  if (hamburger) hamburger.addEventListener('click', openNav);
  if (navClose)  navClose.addEventListener('click', closeNav);
  if (overlay)   overlay.addEventListener('click', closeNav);

  // Close nav on escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  // ---- Scroll-triggered fade-in ----
  const fadeEls = document.querySelectorAll('.rv-fade-in');
  if ('IntersectionObserver' in window && fadeEls.length) {
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    fadeEls.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      io.observe(el);
    });
  }

  // ---- Animate-on-scroll for feature cards / steps ----
  const animEls = document.querySelectorAll('.rv-feature-card, .rv-step, .rv-cat-card, .rv-inside-item, .rv-testimonial, .rv-disaster-card, .rv-product-card');
  if ('IntersectionObserver' in window && animEls.length) {
    const cardIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }, 60 * (entry.target.dataset.delay || 0));
          cardIO.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    animEls.forEach(function (el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      el.dataset.delay = i % 4;
      cardIO.observe(el);
    });
  }

  // ---- Smooth scroll for anchor links ----
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        closeNav();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ---- Cart count live update ----
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const badge = document.querySelector('.rv-cart-count');
        if (badge) {
          badge.textContent = cart.item_count > 0 ? cart.item_count : '';
        }
      })
      .catch(function () {});
  }

  // Update cart after add-to-cart form submissions
  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      setTimeout(updateCartCount, 800);
    });
  });

})();
